export default {"src":"/_next/static/media/SQSP.255319d3.svg","height":18,"width":18};